/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Timeline_IntroInputs */

const en_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a decade, then tap a moment to watch or read the story.`)
};

const es_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una década y toca un momento para ver o leer la historia.`)
};

const de_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie ein Jahrzehnt und tippen Sie auf einen Moment, um die Geschichte anzusehen oder zu lesen.`)
};

const zh_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个年代，然后点按某个瞬间观看或阅读故事。`)
};

const ar_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر عقدًا، ثم انقر على لحظة لمشاهدة القصة أو قراءتها.`)
};

const fr_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une décennie, puis touchez un moment pour regarder ou lire l'histoire.`)
};

const vi_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một thập niên, rồi chạm vào một khoảnh khắc để xem hoặc đọc câu chuyện.`)
};

const sw_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chagua muongo, kisha gusa tukio ili kutazama au kusoma hadithi.`)
};

const th_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกทศวรรษ จากนั้นแตะช่วงเวลาเพื่อดูหรืออ่านเรื่องราว`)
};

const bs_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaberite deceniju, zatim dodirnite trenutak da pogledate ili pročitate priču.`)
};

const ja_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年代を選び、モーメントをタップしてストーリーを視聴または読む。`)
};

const ko_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연대를 고른 뒤 순간을 탭해 이야기를 보거나 읽으세요.`)
};

const pt_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma década e toque em um momento para assistir ou ler a história.`)
};

const it_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un decennio, poi tocca un momento per guardare o leggere la storia.`)
};

const sv_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett årtionde och tryck sedan på ett ögonblick för att se eller läsa historien.`)
};

const nl_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een decennium en tik op een moment om het verhaal te bekijken of te lezen.`)
};

const da_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et årti, og tryk derefter på et øjeblik for at se eller læse historien.`)
};

const nb_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg et tiår, og trykk deretter på et øyeblikk for å se eller lese historien.`)
};

const fi_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse vuosikymmen ja napauta hetkeä katsoaksesi tai lukeaksesi tarinan.`)
};

const pl_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz dekadę, a następnie stuknij chwilę, by obejrzeć lub przeczytać historię.`)
};

const ru_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите десятилетие, затем коснитесь момента, чтобы посмотреть или прочитать историю.`)
};

const tr_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir on yıl seçin, ardından hikâyeyi izlemek veya okumak için bir ana dokunun.`)
};

const hi_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक दशक चुनें, फिर कहानी देखने या पढ़ने के लिए किसी क्षण पर टैप करें।`)
};

const id_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih sebuah dekade, lalu ketuk momen untuk menonton atau membaca kisahnya.`)
};

const ms_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih satu dekad, kemudian ketik satu momen untuk menonton atau membaca ceritanya.`)
};

const cs_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte dekádu a klepnutím na moment příběh zhlédnete nebo si jej přečtete.`)
};

const el_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιλέξτε μια δεκαετία και πατήστε μια στιγμή για να δείτε ή να διαβάσετε την ιστορία.`)
};

const he_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו עשור, ואז הקישו על רגע כדי לצפות בסיפור או לקרוא אותו.`)
};

const af_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies 'n dekade, tik dan op 'n moment om die storie te kyk of lees.`)
};

const hu_hof_timeline_intro = /** @type {(inputs: Hof_Timeline_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válasszon egy évtizedet, majd koppintson egy pillanatra a történet megtekintéséhez vagy elolvasásához.`)
};

/**
* | output |
* | --- |
* | "Pick a decade, then tap a moment to watch or read the story." |
*
* @param {Hof_Timeline_IntroInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_timeline_intro = /** @type {((inputs?: Hof_Timeline_IntroInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Timeline_IntroInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_timeline_intro(inputs)
	if (locale === "de") return de_hof_timeline_intro(inputs)
	if (locale === "zh") return zh_hof_timeline_intro(inputs)
	if (locale === "ar") return ar_hof_timeline_intro(inputs)
	if (locale === "fr") return fr_hof_timeline_intro(inputs)
	if (locale === "vi") return vi_hof_timeline_intro(inputs)
	if (locale === "sw") return sw_hof_timeline_intro(inputs)
	if (locale === "th") return th_hof_timeline_intro(inputs)
	if (locale === "bs") return bs_hof_timeline_intro(inputs)
	if (locale === "ja") return ja_hof_timeline_intro(inputs)
	if (locale === "ko") return ko_hof_timeline_intro(inputs)
	if (locale === "pt") return pt_hof_timeline_intro(inputs)
	if (locale === "it") return it_hof_timeline_intro(inputs)
	if (locale === "sv") return sv_hof_timeline_intro(inputs)
	if (locale === "nl") return nl_hof_timeline_intro(inputs)
	if (locale === "da") return da_hof_timeline_intro(inputs)
	if (locale === "nb") return nb_hof_timeline_intro(inputs)
	if (locale === "fi") return fi_hof_timeline_intro(inputs)
	if (locale === "pl") return pl_hof_timeline_intro(inputs)
	if (locale === "ru") return ru_hof_timeline_intro(inputs)
	if (locale === "tr") return tr_hof_timeline_intro(inputs)
	if (locale === "hi") return hi_hof_timeline_intro(inputs)
	if (locale === "id") return id_hof_timeline_intro(inputs)
	if (locale === "ms") return ms_hof_timeline_intro(inputs)
	if (locale === "cs") return cs_hof_timeline_intro(inputs)
	if (locale === "el") return el_hof_timeline_intro(inputs)
	if (locale === "he") return he_hof_timeline_intro(inputs)
	if (locale === "af") return af_hof_timeline_intro(inputs)
	if (locale === "hu") return hu_hof_timeline_intro(inputs)
	return en_hof_timeline_intro(inputs)
});